<div class="config-list-container">
  <div class="search-input-container">
    <app-autocomplete
      inputId="destination-component-2"
      placeholder="Buscar"
      [showSearch]="false"
      maxLength="200"
      [autoSearchResults]="autocomplete" 
      (ElementSelected)="setElement($event)"
      (autocompleteSearch)="searchElement($event)" value="description"
      [enhanveOnHover]="true">
    </app-autocomplete>  
  </div>

  <div class="container-list">
    <table>
      <colgroup>
        <col class="first-col">
      </colgroup>
      <tr class="no-border-top">
        <th>
          <div class="header-item">
            <span>Empresa</span>
            <div class="arrows-header">
              <img id="company-up-arrow" src="../../../../assets/svgs/icon_order_up.svg" alt="Seta para cima" (click)="orderBy({ field: 'company.name', type: 'ASC' })">
              <img id="company-up-down" src="../../../../assets/svgs/icon_order_down.svg" alt="Seta para baixo" (click)="orderBy({ field: 'company.name', type: 'DESC' })">
            </div>
          </div>
        </th>
        <th>
          <div class="header-item">
            <span>Mercado</span>
            <div class="arrows-header">
              <img id="market-up-arrow" src="../../../../assets/svgs/icon_order_up.svg" alt="Seta para cima" (click)="orderBy({ field: 'markets.name', type: 'ASC' })">
              <img id="market-up-down" src="../../../../assets/svgs/icon_order_down.svg" alt="Seta para baixo" (click)="orderBy({ field: 'markets.name', type: 'DESC' })">
            </div>
          </div>
        </th>
      </tr>
      <tr [ngClass]="{'no-border-bot': last}" *ngFor="let item of companiesList; let i = index; let last = last">
        <td id="company-{{i}}">{{item.company}}</td>
        <td id="market-{{i}}">
          <div style="width: 15%">
            {{getMarketsDescription(item.markets)}}
          </div>
        </td>
  
        <div class="tbl-hover-action tbl">
          <div id="options-icon-{{i}}" class="btn-action" [matMenuTriggerFor]="beforeMenu">
            <img src="../../../../assets/svgs/i_btn_hover_table.svg" alt="Actions">
          </div>
          <mat-menu #beforeMenu="matMenu" xPosition="before">
            <button id="menu-item-{{i}}" mat-menu-item (click)="navigatoToConf(item.company_id)">Configurar</button>
          </mat-menu>
        </div>
      
      </tr>
    </table>
  </div>

</div>